import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import Swal from 'sweetalert2';
import { forEach } from '@angular/router/src/utils/collection';
//PerfilPermissoesComponent
//PerfilUsuarioComponent
@Component({
	selector: 'app-perfil-permissoes',
	templateUrl: './perfil-permissoes.component.html',
	styleUrls: ['./perfil-permissoes.component.css'],
	animations: [loadingFade, modal, alert]
})
export class PerfilPermissoesComponent implements OnInit {
	public loading = false;
	public gruposPerfil;
	public menuItens;
	public menuFilhos;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;
	public expandir_menu = "ND";
	public expandir_menu_filho = "ND";
	public css_title: string;
	public usuario_perfil;
	public usuario_perfil_id_aberto;
	public menu_id_filho_aberto;

	constructor(private perfilUsuarioSvc: PerfilUsuarioService,
		private authSvc: AuthService
		) { }

	ngOnInit() {

		this.usuario_perfil = this.authSvc.getPerfil();
		this.pegaPerfil();
		
	}

	pegaPerfil(){
		this.loading = true;
		this.perfilUsuarioSvc.getPerfil().then((data: any) => {
			this.gruposPerfil = data;
			this.count = this.gruposPerfil.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);scrollBy
			this.loading = false;
		});
	}

	getMenu(){
		this.loading = true;
		this.perfilUsuarioSvc.getByMenuPai().then((data: any) => {
			this.menuItens = data;
			this.loading = false;
		}).catch((err) => {
			console.log(err);scrollBy
			this.loading = false;
		});
	}


	getByMenuPaiContaFilho(usuario_perfil_id){

		this.loading = true;
		this.perfilUsuarioSvc.getByMenuPaiContaFilho(usuario_perfil_id).then((data: any) => {

			this.menuItens = data;


			this.loading = false;
		}).catch((err) => {
			console.log(err);scrollBy
			this.loading = false;
		});
	}


	getByMenuFilho(menu_id_pai,usuario_perfil_id){
		this.loading = true;
		this.perfilUsuarioSvc.getByMenuFilho(menu_id_pai,usuario_perfil_id,this.usuario_perfil).then((data: any) => {
			this.menuFilhos = data;
			this.loading = false;

			document.getElementById("text-menu-"+ menu_id_pai).style.display = "none";


		}).catch((err) => {
			console.log(err);scrollBy
			this.loading = false;
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	expandirMenuPerfil(usuario_perfil_id){

		if (typeof this.usuario_perfil_id_aberto !== 'undefined') {
			document.getElementById("text-"+ this.usuario_perfil_id_aberto).style.display = "block";
		}

		this.usuario_perfil_id_aberto = usuario_perfil_id;

		this.getByMenuPaiContaFilho(usuario_perfil_id);
		this.expandir_menu = usuario_perfil_id;
		//this.expandir_menu_filho = "minus";
		document.getElementById("text-"+ usuario_perfil_id).style.display = "none";
		
	}

	minimizarMenuPerfil(usuario_perfil_id){
		//console.log("[minimizarMenuPerfil]")
		this.expandir_menu = "minus";
		document.getElementById("text-"+ usuario_perfil_id).style.display = "block";

		this.pegaPerfil();
	}


	expandirMenuFilho(menu_id_pai,usuario_perfil_id){
		
		if (typeof this.menu_id_filho_aberto !== 'undefined') {
			document.getElementById("text-menu-"+ this.menu_id_filho_aberto).style.display = "block";
		}

		this.menu_id_filho_aberto = menu_id_pai;

		this.getByMenuFilho(menu_id_pai,usuario_perfil_id);
		this.expandir_menu_filho = menu_id_pai;
		document.getElementById("text-menu-"+ menu_id_pai).style.display = "none";
	
	}

	minimizarMenuFilho(menu_id,usuario_perfil_id){
		//console.log("[minimizarMenuFilho]")
		this.expandir_menu_filho = "minus";
		document.getElementById("text-menu-"+ menu_id).style.display = "block";
		
	}


	setPermissao(valor,usuario_perfil_id,menu_id,menu_perfil_id,editar,menu_id_pai,tipo_alteracao){




		this.perfilUsuarioSvc.getByVerificaPermissao(usuario_perfil_id,menu_id).then((data: any[]) => {

			let toSend;
			let toSendup;

			if(typeof data[0] !== "undefined"){

				//console.log("[ALTERA]")

				if(tipo_alteracao == 'v'){

					let loVisualizar;
					if(valor.target.checked){
						loVisualizar = true;
					}else{
						loVisualizar = false;
					}
					

					toSendup = ({
						'usuario_perfil_id': usuario_perfil_id,
						'menu_id': menu_id,
						'visualizar': loVisualizar,
						'menu_perfil_id': menu_perfil_id
					});



					this.perfilUsuarioSvc.visualizarPerfilUsuario(toSendup).then((data) => {
						console.log('resp', data);
		
					}).catch(err => {
						console.log(err);
	
					});

				}else{


					
					let loEditar;
					if(valor.target.checked){
						loEditar = true;
					}else{
						loEditar = false;
					}

					toSendup = ({
						'usuario_perfil_id': usuario_perfil_id,
						'menu_id': menu_id,
						'editar': loEditar,
						'menu_perfil_id': menu_perfil_id
					});



					this.perfilUsuarioSvc.editaPerfilUsuario(toSendup).then((data) => {
						console.log('resp', data);
		
					}).catch(err => {
						console.log(err);
	
					});

				}


			}else{

				//console.log("[CADASTRA]")

				let toSend = ({
					'usuario_perfil_id': usuario_perfil_id,
					'menu_id': menu_id,
					'visualizar': true,
					'editar': editar,
				});
		
				this.perfilUsuarioSvc.setMenuPerfil(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
					  type: 'success',
					  title: 'Perfil Alterado com sucesso!',
					  onClose: ()=>{

	
						  this.expandirMenuPerfil(usuario_perfil_id);
						  
							if(menu_id_pai != null){
								this.expandirMenuFilho(menu_id_pai,usuario_perfil_id);
							}else{
								this.expandir_menu_filho = "minus";
							}
	
	
	
					  }
					});
				}).catch(err => {
					console.log(err);
					Swal.fire({
					  type: 'error',
					  title: 'Ops! Algo de errado aconteceu!',
					  text: 'Tente novamente mais tarde!'
					});
				});

			}




			
		}).catch((err) => {
		console.log(err);
		}); 

		



	}
	
}
